<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <back-arrow :title="client !== null ? ( client.isAgency !== false ? client.agencyName : client.name ) : ''"/>
        <show-actions
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        ></show-actions>
      </div>
      <b-card class="mt-2 mb-4 shadow-sm">
        <div class="row">

          <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="client != null && client.lastName !== null">
            <div class="bold-text">
              {{ $t('client.LastName') }}
            </div>
            <div>
              {{client.lastName}}
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="client != null && client.firstName !== null">
            <div class="bold-text">
              {{ $t('client.FirstName') }}
            </div>
            <div>
              {{ client.firstName }}
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="client != null && client.civility !== null">
            <div class="bold-text">
              {{ $t('client.Civility') }}
            </div>
            <div>
              {{  client.civility === 'MR' ? 'Monsieur' :  client.civility === 'MME' ? 'Madame' : 'N/A' }}
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="client != null && client.phoneNumber !== null">
            <div class="bold-text">
              {{ $t('client.PhoneNumber') }}
            </div>
            <div>
              {{  client.phoneNumber }}
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="client != null && client.cellphoneNumber !== null">
            <div class="bold-text">
              {{ $t('client.CellphoneNumber') }}
            </div>
            <div>
              {{  client.cellphoneNumber }}
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="client != null && client.email !== null">
            <div class="bold-text">
              {{ $t('client.Email') }}
            </div>
            <div>
              <b-link :href="'mailto:'+ client.email">{{ client.email }}</b-link>
            </div>
          </div>
        </div>

        <div class="row" v-if="client != null && (client.isAgency && client.agencyName !== null)">
          <div class="col-12 col-md-6 col-lg-4 mb-2" >
            <div class="bold-text">
              {{ $t('client.Agency') }}
            </div>
            <div>
              {{  client.agencyName }}
            </div>
          </div>
        </div>

        <div v-if="client != null && (client.address !== null || client.postalCode != null || client.city !== null || client.additionalAddress !== null)">
          <div>
            <div class="card-subtitle mt-3 mb-2">{{$t('applicant.address')}}</div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="client.address !== null">
              <div class="bold-text">
                {{ $t('addressIntervention.address') }}
              </div>
              <div>
                {{ client.address }}
              </div>
            </div>

            <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="client.postalCode !== null">
              <div class="bold-text">
                {{ $t('addressIntervention.postalCode') }}
              </div>
              <div>
                {{client.postalCode}}
              </div>
            </div>

            <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="client.city !== null">
              <div class="bold-text">
                {{ $t('addressIntervention.city') }}
              </div>
              <div>
                {{ client.city }}
              </div>
            </div>

            <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="client.additionalAddress !== null">
              <div class="bold-text">
                {{ $t('addressIntervention.AdditionalAddress') }}
              </div>
              <div>
                {{client.additionalAddress}}
              </div>
            </div>
          </div>
        </div>

        <div v-if="tenantOfAddresses.length > 0 || ownerOfAddresses.length > 0 || agencyOfAddresses.length > 0">
          <div class="line-separator mb-3 mt-3"></div>

          <div class="row" v-if="!client.isAgency">
            <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="tenantOfAddresses.length > 0">
              <div class="bold-text mb-2">
                {{ $t('isTenantFrom') }}
              </div>
              <div v-for="address in tenantOfAddresses">
                <div class="d-flex align-items-center mb-3">
                  <button class="show-action-btn mr-2" @click="goToCreateIntervention(address)">
                    {{ $t('intervention') }}
                  </button>
                  <a class="force-link" href="javascript:void(0)" @click="goToAddressIntervention(address.id)">{{ address.name }}, {{address.additionalAddress}} </a>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="ownerOfAddresses.length > 0">
              <div class="bold-text mb-2">
                {{ $t('isOwnerFrom') }}
              </div>
              <div>
                <div v-for="address in ownerOfAddresses">
                  <div class="d-flex align-items-center mb-3">
                    <button class="show-action-btn mr-2" @click="goToCreateIntervention(address)">
                      {{ $t('intervention') }}
                    </button>
                    <a class="force-link" href="javascript:void(0)" @click="goToAddressIntervention(address.id)">{{ address.name }}, {{address.additionalAddress}} </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="agencyOfAddresses.length > 0">
              <div class="bold-text mb-2">
                {{ $t('isAgencyFrom') }}
              </div>
              <div>
                <div v-for="address in agencyOfAddresses">
                  <div class="d-flex align-items-center mb-3">
                    <button class="show-action-btn mr-2" @click="goToCreateIntervention(address)">
                      {{ $t('intervention') }}
                    </button>
                    <a class="force-link" href="javascript:void(0)" @click="goToAddressIntervention(address.id)">{{ address.name }}, {{address.additionalAddress}} </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </b-card>
    </b-container>

    <!-- Modal Delete -->
    <client-delete-modal :selectedClient="client" @didDeleteClient="didDeleteClient()"></client-delete-modal>
  </div>
</template>

<script>
import api from '../../services/api';
import BackArrow from "../../components/b122/BackArrow";
import ShowActions from "../../components/b122/ShowActions";
import B122Table from "../../components/b122/B122Table";
import ClientDeleteModal from "./ClientDeleteModal";
import {dateUtils} from "@/mixins/utils";
import ZoomOnImage from "../../components/b122/ZoomOnImage";

export default {

  name: 'ClientShow',

  components: {
    BackArrow,
    ShowActions,
    B122Table,
    ClientDeleteModal,
    ZoomOnImage
  },

  data() {
    return {
      clientId: this.$route.params.clientId,
      client: null,
      tenantOfAddresses: [],
      ownerOfAddresses: [],
      agencyOfAddresses: []
    }
  },

  mounted() {
    this.fetchClient()
  },

  methods: {

    fetchClient() {
      return api
        .get(`/client/${this.clientId}`)
        .then(response => {
          this.client = response.data
          if(this.client.isAgency){
            this.fetchAddressesForAgency()
          }else{
            this.fetchAddressesForTenant()
            this.fetchAddressesForOwner()
          }
        })
    },

    fetchAddressesForAgency() {
      return api
        .get(`/addressIntervention/getAddressesForClient?clientId=${this.clientId}&clientType=agency`)
        .then(response => {
          this.agencyOfAddresses = response.data
        })
    },

    fetchAddressesForTenant() {
      return api
        .get(`/addressIntervention/getAddressesForClient?clientId=${this.clientId}&clientType=tenant`)
        .then(response => {
          this.tenantOfAddresses = response.data
        })
    },

    fetchAddressesForOwner() {
      return api
        .get(`/addressIntervention/getAddressesForClient?clientId=${this.clientId}&clientType=owner`)
        .then(response => {
          this.ownerOfAddresses = response.data
        })
    },

    goToAddressIntervention(id){
      this.$router.push({
        name: 'AddressInterventionShow',
        params: {
          addressInterventionId: id
        }
      })
    },

    goToCreateIntervention(addressIntervention){
      this.$router.push({
        name: 'InterventionCreate',
        params: {
          selectedAddressIntervention: addressIntervention,
          selectedApplicant : this.client
        }
      })
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'ClientEdit',
        params: {
          clientId: this.client.id
        }
      })
    },

    clickOnDeleteBtn() {
      this.$bvModal.show('client-delete-modal')
    },

    didDeleteClient() {
      this.$router.push({
        name: 'AddressInterventionIndex'
      }, () => {})
    },

  }
}
</script>

<style scoped>
  .show-action-btn {
    background-color: var(--main-color);
    border: none;
    color: var(--main-white);
    border-radius: var(--main-border-radius);
    padding: 4px 8px;
  }

  .show-action-btn:hover {
    background-color: var(--main-color-hover);
  }
</style>



// WEBPACK FOOTER //
// src/views/client/ClientShow.vue